//#region src/components/ApplicationMenu/constants.ts
var e = "Help", t = "Onboarding", n = "Download", r = "Report";
//#endregion
export { n as DOWNLOAD_SUBMENU_ID, e as HELP_SUBMENU_ID, t as ONBOARDING_SUBMENU_ID, r as REPORT_SUBMENU_ID };
